module.exports = __webpack_public_path__ + "static/media/icon_view_front.bbf1e86e.svg";